import { breakpoints } from '../constants'
import {
    BLUE,
    FONTYELLOWBLACKFRIDAYHEADER,
    PRIMARY_COLOR,
    SECUNDARY_COLOR,
    BTN_CONFIRM_COLOR_PRIMARY,
    BTN_CONFIRM_COLOR_SECONDARY,
    BTN_CANCEL_COLOR,
    BACKGROUND_CONFIRM_PRIMARY_COLOR,
    BACKGROUND_CONFIRM_SECONDARY_COLOR,
} from './colors.style'
import Browser from './../services/Browser'
import { isBlackFriday } from '../helpers/isBlackFriday'

const borderRadius = '5px'

const shadow = () => `
    position: relative;
    
    &:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1;
        box-shadow: 2px 15px 25px 5px rgba(0, 0, 0, 0.2);
        border-radius: ${borderRadius};
    }
`

const dropShadow = () => `
    box-sizing: border-box;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
`

const confirmGradient = () => `
    linear-gradient( ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : BTN_CONFIRM_COLOR_PRIMARY
    }, ${BTN_CONFIRM_COLOR_SECONDARY});
`

const blueGradient = () => `
    linear-gradient(to bottom, ${BACKGROUND_CONFIRM_PRIMARY_COLOR} 0%, ${BACKGROUND_CONFIRM_SECONDARY_COLOR} 100%);
`

const dangerGradient = () => `
    linear-gradient(to bottom, #cc4f4f 0%,#c15555 100%);
`

const orangeButton = () => `
    color: #FFF;
    text-decoration: none;
    font-size: 1.8rem;
    text-align: center;
	font-weight: 600;
	cursor: pointer;
	width: auto;
	padding: 1.8rem 4rem;
    transition: all 0.5s;
    box-sizing: border-box;
    
    &:hover {
        opacity: 0.8;
        transition: all 0.5s;
    }
    
    &:disabled {
        opacity: 0.7;
        cursor: auto;
    }
    
    display: inline-block;
    background: ${confirmGradient()};
`

const roundOrangeButton = () => `
    border-radius: 100px;
    ${orangeButton()}
`

const squareOrangeButton = ({ height } = {}) => `
    @media (max-width: ${breakpoints.MOBILE}px) {
		width: 100%;
    }
    
    border-radius: ${borderRadius};
    ${orangeButton()}
    ${height !== undefined && height !== null
        ? `
        height: ${height};
        padding-bottom: 0;
        padding-top: 0;
    `
        : ''
    }
`

const container = (props) => `
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
    margin-top:15px;
    
    ${props.small
        ? `@media (min-width: 600px) {
            max-width: 600px;
            width: 100%;
            margin-right: auto;
            margin-left: auto;
        }`
        : props.medium
            ? `@media (min-width: 800px) {
            max-width: ${Browser.isEdge() ? '950px' : '900px'};
            width: 100%;
            margin-right: auto;
            margin-left: auto;
        }`
            : `@media (min-width: 1200px) {
            max-width: 1200px;
            width: 100%;
            margin-right: auto;
            margin-left: auto;
        }`
    }
`

const textInputBorder = () => ` 
    border: 1px solid #E0E0E0;
`

const textInputShadow = () => `
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15)
`

/**
 *
 * @param {Object} [options]
 * circle: to have circle around arrows
 */
const styleSlideArrows = (options) => {
    const { circle = false } = options ? (() => options)() : {}
    return `
        .slick-prev,
        .slick-next {
            &:before {
                color: ${circle ? BLUE : '#FFF'};
                ${!circle &&
        (() => `
                    font-family: "FontAwesome";
                    font-size: 5rem;
                `)()
        }
            }
        }

        .slick-prev {
            left: 0;
            z-index: 1;
            ${!circle &&
        (() => `&:before {
                content: "\\f104";
            }`)()
        }
        }

        .slick-next {
            right: 0;
            ${!circle &&
        (() => `&:before {
                content: "\\f105";
            }`)()
        }
        }
    `
}

export {
    borderRadius,
    container,
    confirmGradient,
    blueGradient,
    dangerGradient,
    roundOrangeButton,
    shadow,
    dropShadow,
    textInputBorder,
    textInputShadow,
    squareOrangeButton,
    styleSlideArrows,
}
